export function quoteModule(item) {
  const quoteModule = `
  <blockquote class="container grid grid-cols-12 mb-10 lg:min-h-[120px]">
      <div class="col-span-12 md:col-span-8 md:col-start-3  relative flex items-center justify-center flex-wrap">
          <svg class="absolute top-0 left-0 w-[90px] md:w-[187px]"><use xlink:href="/spritemap.svg#sprite-quote"></use></svg>
          <div class="w-[73%] z-10 relative pt-7">
              <p class="text-lg font-bold text-blue">${item.properties.quote}</p>
              ${item.properties.author != "" ? `<p class="text-blue pt-6">${item.properties.author}</p>` : ""}              
          </div>
      </div>
  </blockquote>
  `;
  return quoteModule;
}
